export default "__VITE_ASSET__Cs2JClFr__"